import { IExtendedError } from '../ExtendedError.interface';
import { mutationCloseAnnouncement, queryAnnouncements } from './Announcement.graphql';
import { IAnnouncements } from './Announcement.interface';
import ApplicationFormSCSInitializer from '../../../applicationform/ApplicationFormSCSInitializer';
import { AbstractRequestApi } from '../AbstractRequestApi';
import { IGraphQL } from '../GraphQL.interface';

class ApplicationFormAnnouncementApi extends AbstractRequestApi {
  constructor() {
    super(
      () => ApplicationFormSCSInitializer.apiConfig().applicationFormApi,
      'ApplicationFormAnnouncementApi',
      () => ApplicationFormSCSInitializer.queryConfig(),
      () => ApplicationFormSCSInitializer.authenticationRequiredHandler()
    );
  }

  fetchAnnouncements(): Promise<IGraphQL<IAnnouncements>> {
    return this.makeCacheableGraphQlRequest(
      ApplicationFormSCSInitializer.apiConfig().paths.pathToGraphQL,
      queryAnnouncements(),
      'fetchAnnouncements'
    ).then(response => {
      response.data.getAnnouncements.forEach(it => (it.closeFunction = () => this.closeAnnouncement(it.id)));
      return {
        data: {
          announcements: response.data.getAnnouncements,
        },
        extensions: response.data.extensions,
      } as IGraphQL<IAnnouncements>;
    });
  }

  closeAnnouncement(id: string): Promise<boolean> {
    const query = {
      query: mutationCloseAnnouncement(id),
    };
    return this.postGraphQlRequest(
      ApplicationFormSCSInitializer.apiConfig().paths.pathToGraphQL,
      'closeAnnouncement',
      query
    )
      .then<boolean>((response: any) => response.data.closeAnnouncement)
      .catch((error: IExtendedError) => {
        this.handleResponse(error);
        return null;
      });
  }
}

export default new ApplicationFormAnnouncementApi();
